import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CompanyHighlightop from "./CompanyHighlightop";
import styles from "../commanstyles.module.css";
import FinanialParameters from "./FinanialParameters";
import PrincipalBusinessActivities from "./PrincipalBusinessActivities";
import NameHistory from "./NameHistory";
import RelatedPartyTransactions from "./RelatedPartyTransactions";
import LegalCasesOfFinancialDispute from "./legalCasesofFinanicialDispute";
import { gethighlightsdata } from "../../../Services/APIrequests";
import { RotatingLines } from "react-loader-spinner";
import Corporate_social_responsibility from "./Corporate_social_responsibility";
import MSME_supplier_payment_delays from "./MSME_supplier_payment_delays";
import Demat_of_shares from "./Demat_of_shares";

function CompanyHighlights({ isSubScribe, companyInfo,refreshLoading,companyName }) {
  const { cin } = useParams();
  const [financialData, setFinancialData] = useState({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isLlpCompany, setIsLlpCompany] = useState(false);
  // Define tabs and filter based on company type
  console.log(companyInfo)
  const CompanyHighlightsdata = [
    { title: "Principal Business Activities", key: "Principal_business_activities" },
    { title: "Name History", key: "Name_history" },
    { title: "Related party transactions", key: "Party_transactions" },
    { title: "Corporate Social Responsibility", key: "Corporate_social_responsibility" },
    { title: "MSME Supplier Payment Delays", key: "MSME_supplier_payment_delays" },
    { title: "Demat Of Shares", key: "Demat_of_shares" },
  ].filter((item) => {
    // Hide specific tabs for LLP companies
    if (companyName?.includes("LLP")) {
 
      if ( item.key === "Corporate_social_responsibility"|| item.key=='MSME_supplier_payment_delays' || item.key === "Demat_of_shares") {
        return false;
      }
    }
    return true;  
  });

  const [activeTab, setActiveTab] = useState(CompanyHighlightsdata[0]?.key || "");

  useEffect(() => {
    const fetchHighlightsData = async () => {
      try {
        const response = await gethighlightsdata(cin);
        const data = response?.data || {};
        setFinancialData(data);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch highlights data.");
        setLoading(false);
      }
    };
    if(refreshLoading==false){
       fetchHighlightsData();
    }
  }, [cin,refreshLoading]);

  if (loading)
    return (
      <div className={styles.loading}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <RotatingLines
            height="80"
            width="80"
            color="#4fa94d"
            ariaLabel="circles-loading"
            visible={true}
          />
        </div>
      </div>
    );

  if (error) return <div className={styles.error}>{error}</div>;

  const topData = financialData?.Top_Data || { Revenue: 0, ProfitAfterTax: 0 };

  const renderTabContent = () => {
    switch (activeTab) {
      case "Principal_business_activities":
        return (
          <PrincipalBusinessActivities
            isSubScribe={isSubScribe}
            data={financialData?.Principal_business_activities}
          />
        );
      case "Name_history":
        return (
          <NameHistory
            isSubScribe={isSubScribe}
            data={financialData?.Name_history}
          />
        );
      case "Party_transactions":
        return (
          <RelatedPartyTransactions
            isSubScribe={isSubScribe}
            data={financialData?.Party_transactions}
          />
        );
      case "Corporate_social_responsibility":
        return (
          <Corporate_social_responsibility
            isSubScribe={isSubScribe}
            data={financialData?.Csr}
          />
        );
      case "MSME_supplier_payment_delays":
        return (
          <MSME_supplier_payment_delays
            isSubScribe={isSubScribe}
            data={financialData?.Msme}
          />
        );
      case "Demat_of_shares":
        return (
          <Demat_of_shares
            isSubScribe={isSubScribe}
            data={financialData?.Demat}
          />
        );
      default:
        return <div>No data available</div>;
    }
  };

  return (
    <div>
      <div className={styles.structure_container}>
        {/* Render Tabs */}
        <div className={styles.finac_box}>
          {CompanyHighlightsdata.map((item) => (
            <div
              key={item.key}
              className={`${styles.finac_box_text_container} ${
                activeTab === item.key ? styles.Active_subTab : ""
              }`}
              onClick={() => setActiveTab(item.key)}
            >
              <h4 className={styles.finac_box_header}>{item.title}</h4>
            </div>
          ))}
        </div>

        {/* Render Active Tab Content */}
        <div>{renderTabContent()}</div>
      </div>
    </div>
  );
}

export default CompanyHighlights;
